import styled, { css } from 'styled-components'
import { theme } from '@notino/react-styleguide'

// styles
import { SALONS_PAGE_MOBILE_BREAKPOINT } from '../../../../styles/constants'

export const SubcategoriesSliderWrapper = styled.div`
	margin-top: 16px;

	@media (min-width: ${SALONS_PAGE_MOBILE_BREAKPOINT}) {
		margin-top: 40px;
	}
`

export const SubcategoryButton = styled.button<{ $isSelected: boolean }>`
	height: 32px;
	background-color: ${theme.color.background.primary};
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 12px;
	padding: 0 16px;
	outline: none;
	border: 1px solid;
	transition: all 0.3s ease;
	white-space: nowrap;

	&:not(:disabled) {
		color: rgb(64, 64, 64);
		cursor: pointer;

		&:hover {
			background-color: rgb(245, 245, 245);
		}
	}

	&:not(:last-child) {
		margin-right: 8px;
	}

	${({ $isSelected }) =>
		$isSelected
			? css`
					border-color: ${theme.color.common.black};
					&:not(:disabled) {
						&:hover {
							border-color: ${theme.color.common.black};
						}
					}
				`
			: css`
					border-color: ${theme.color.border.divider};
					&:not(:disabled) {
						&:hover {
							border-color: ${theme.color.border.divider};
						}
					}
				`};

	@media (min-width: ${SALONS_PAGE_MOBILE_BREAKPOINT}) {
		&:first-child {
			margin-left: 0;
		}
		&:last-child {
			margin-right: 0;
		}
	}
`
